import styled from "styled-components";

import { media } from "../../common/media";

const SearchVideoFormContainer = styled.section`
  padding-top: 14px;
  width: 50px;
  display: ${(props) => (props.scrolling === "true" ? "block" : "none")};

  ${media.desktop`
    padding-top: 0;
    padding-right: 80px;
  `};

  ${media.phone`
    padding-top: 0;
    padding-left: 30px;
    padding-right: 20px;
  `};

  input[type="search"] {
    height: 40px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    background: #fff;
    border: 1px solid #bababa;
    padding-left: 15px;
    padding-right: 15px;
    border-right: 0;
    color: #4a4a4a;
    font-size: 16px;

    &.error {
      border: 2px solid ${(props) => props.theme.colors.primary.main};
    }

    ${media.tablet`
      font-size: 10px;
    `};

    ${media.phone`
      padding-left: 5px;
      padding-right: 5px;
      font-size: 12px;
    `}
  }

  input[type="submit"] {
    background: ${(props) => props.theme.colorFlamingo};
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    border: 1px solid #bababa;
    height: 40px;
    color: transparent;
    width: 50px;
    font-size: 16px;
    transition: all 0.6s ease 0s;
    border-left: 0;
  }
  svg.search-icon {
    width: 20px;
    position: absolute;
    right: 16px;
    top: 10px;
    fill: #fff;
  }

  .search {
    position: relative;
    width: 70%;
    .search--icon {
      height: 100%;
      position: absolute;
      pointer-events: none;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .search--button {
      border-radius: 50% !important;
      margin-left: -10px;
      pointer-events: none;
    }
    .search--root {
      width: calc(100% - 40px);
      .search--input {
        width: 100%;
        &::placeholder {
          font-size: 9px;
        }
      }
    }
    hr.error {
      background: ${(props) => props.theme.colorFlamingo};
    }
  }

  @media screen and (max-width: 1220px) {
    .search__form--container {
      form {
        border: none !important;
      }
      .form__fields input[type="text"] {
        display: none;
      }
      .star-icon {
        display: none;
      }
    }

    .search .search--button {
      margin-left: 10px;
    }
    .search {
      .search--button {
        pointer-events: auto;
      }
      hr {
        display: none;
      }
    }
  }

  @media (min-width: 1221px) and (max-width: 1617px) {
    width: ${(props) => (props.logged ? "calc(100% - 650px)" : "calc(100% - 750px)")};

    .search__header {
      width: 100%;
    }
  }

  @media screen and (min-width: 1618px) {
    width: 60%;
  }
`;

export default SearchVideoFormContainer;
